import React from "react";
import { Bar } from 'react-chartjs-2';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';

  import "chartjs-plugin-datalabels";
  import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from "chart.js";
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  import 'chart.js/auto';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels // Register the DataLabels plugin
  );
  

  const BarChartSubquestionsModelTwo = (props) => {
        const { t } = useTranslation();
    
  const options = {
  responsive: true,
   maintainAspectRatio: false,
   layout: {
      padding: {
        top: 32,
       
     
  
      }
    },
   scales: {
    x: {
        display: true,
          title: {
          display: false,
          font: {
            family: 'Comic Sans MS',
            size: 24,
            weight: 'bold',
            lineHeight: 1.2,
          },
          padding: {top: 20, left: 0, right: 0, bottom: 0}
        }
       
    },
          y: {
        display: true,
        position: "right",
        title: {
          display: true,
          text: t("graphA11_ybar_label1"),
           color: "rgb(84, 84, 84)", 
            font: {
              size: 13,
              weight: "500",
            },
        },
         padding: {top: 50, left: 0, right: 0, bottom: 0}
      }
    },
  plugins: {
         tooltip: {
        callbacks: {
              title: function(context) {
            let title = context[0].label.replace(/[ ,.]/g,' ');
            return title;
              }
    }
},
    legend: {
      display: false,
      position: "bottom",
           onClick: null

      // align: "center",
     
      
    },
    title: {
      display: true,
        align:'start',
        text: props.titleX,
      position:'bottom',
       color: "rgb(84, 84, 84)", 
            font: {
              size: 10,
              weight: "500",
            },
    },
  
      datalabels: {
          align: 'end',
            anchor: 'end',
            color: "black", 
            font: {
              size: 14,
              weight: "500",
            },
  },
},

  };


const labels = 
props.size.x > 600 ? props.label.map((lab) => lab.split(" ")) : 
props.mobileLabels;

const dataSet = {
  labels,
  datasets: [
    {
    label: "",
      data: props.data,
      backgroundColor: 
      props.data.length === 8 ? ["rgb(160, 203, 232)", "rgb(176, 122, 161)", "rgb(242, 142, 43)", "rgb(78, 121, 167)","rgb(121, 112, 110)","rgb(216, 181, 166)", "rgb(182, 153, 45)", "rgb(169, 181, 173)"] :
      props.data.length === 5 ?  
      ["rgb(160, 203, 232)", "rgb(176, 122, 161)", "rgb(242, 142, 43)", "rgb(78, 121, 167)","rgb(121, 112, 110)" ] :
      ["rgb(160, 203, 232)", "rgb(176, 122, 161)", "rgb(242, 142, 43)","rgb(121, 112, 110)" ]
    },
  ],
};
    
    return (
      <div >
      <Card className="card-padding-always">
      <Card.Header className="container-header" >
        <p className="vertical-center card-title" >{t(props.graphTitle)}</p></Card.Header>
      <Card.Body> 
        <div 
        className={props.isSubquestion ? "graph-div-subquestion" : "graph-div-main"}>
         <Bar  options={options} data={dataSet} className="graph-height-mobile"/>
         {props.mobileLabels !== undefined && 
         <div className="mobile-legend">
         {props.mobileLabels.map((acr, index) => 
           <p key={acr+index} style={{fontSize: "10px", margin: "0px"}}>{acr + ": "+ props.label[index]}</p>
          )}
         </div>}
         </div>
       </Card.Body>
    </Card> 


   
      </div>
    );
  };
  
  export default BarChartSubquestionsModelTwo;
  
